export default {
  name: "send-mobile-card",
  components: {},
  props: [],
  data() {
    return {
      dialog: true,
      phoneNumber: ""
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleDialog() {
      this.$emit("confirmSendMobile", this.phoneNumber);
      this.dialog = true;
    }
  }
};
